module.exports = __webpack_public_path__ + "static/og_preview-8376c325b53b5474c78d4eb6b6751912.png";